import Actions             from 'Redux/Actions';
import { EventRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from, EMPTY }     from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findEventEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        EventRepository.findById(id)
          .then((event) => Actions.findEventSuccess({ event }))
          .catch(error => Actions.findEventFailure({ error })),
      );
    }),
  );
};
